import React from 'react'
import injectSheet from 'react-jss'
import styles from './school-general.styles'
import Section from '../../../../shared/section/section'
import Segment from '../../../../shared/segment/segment'
import Segments from '../../../../shared/segments/segments'
import Description from '../../../../shared/description/description'
import Label from '../../../../shared/label/label'
import TextArea from 'pobble-components/dist/form-elements/form-text-area'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import Button from 'pobble-components/dist/button'
import FormCheckbox from 'pobble-components/dist/form-elements/form-checkbox'
import classNames from 'classnames'
import { Formik } from 'formik'
import * as Yup from 'yup'

const SchoolGeneral = ({
  classes,
  pending,
  title,
  city,
  country,
  address,
  postcode,
  description,
  hide_year_group,
  website,
  twitter,
  onSubmit
}) => (
  <Formik
    onSubmit={onSubmit}
    validationSchema={Yup.object().shape({
      website: Yup.string().url('This should be a valid url')
    })}
    initialValues={{
      description: description || '',
      hide_year_group: hide_year_group || false,
      website: website || '',
      twitter: twitter || ''
    }}>
    {formikProps => {
      const {
        values,
        handleChange,
        handleSubmit,
        handleBlur,
        touched,
        isValid,
        errors
      } = formikProps
      const maxDesc = 180
      let descCount = maxDesc - values.description.length
      return (
        <form
          onSubmit={handleSubmit}
          className={classNames(classes.form, { [classes.pending]: pending })}>
          <Section
            title="General"
            pending={pending}
            className={classes.section}
            renderHeader={() => (
              <Button
                className={classes.submitButton}
                disabled={!isValid}
                type="submit"
                tall>
                Save changes
              </Button>
            )}>
            <Segments>
              <Segment size={'M'}>
                <Label htmlFor={'title'}>School name</Label>
                <span>{title}</span>
              </Segment>
              <Segment>
                <Description>
                  Displayed on your school’s profile page
                </Description>
              </Segment>
            </Segments>
            <Segments>
              <Segment>
                <Label htmlFor={'city'}>City</Label>
                <span>{city}</span>
              </Segment>
              <Segment>
                <Label htmlFor={'country'}>Country</Label>
                <span>{country}</span>
              </Segment>
              <Segment>
                <Description>
                  Displayed on your school’s profile page
                </Description>
              </Segment>
            </Segments>
            <Segments>
              <Segment>
                <Label htmlFor={'address'}>Address</Label>
                <span>{address}</span>
              </Segment>
              <Segment>
                <Label htmlFor={'postcode'}>Postcode</Label>
                <span>{postcode}</span>
              </Segment>
              <Segment>
                <Description>For administrative purposes</Description>
              </Segment>
            </Segments>
            <Segments>
              <Segment>
                <Label htmlFor={'website'}>Website</Label>
                <FormInput
                  name="website"
                  onChange={handleChange}
                  value={values.website}
                  onBlur={handleBlur}
                  placeholder={'Ex: https://www.school.com'}
                  validationError={touched.website && errors.website}
                />
              </Segment>
              <Segment>
                <Label htmlFor={'twitter'}>Twitter handle</Label>
                <FormInput
                  name="twitter"
                  onChange={handleChange}
                  value={values.twitter}
                  placeholder={'Ex: HeyPobble'}
                />
              </Segment>
              <Segment>
                <Description>
                  Displayed on your school’s profile page
                </Description>
              </Segment>
            </Segments>
            <Segments>
              <Segment size={'M'}>
                <Label htmlFor={'description'}>
                  School description{' '}
                  <span
                    className={classNames(classes.limit, {
                      [classes.max]: descCount < 25
                    })}>
                    {descCount}
                  </span>
                </Label>
                <TextArea
                  validationError={errors.description}
                  name="description"
                  value={values.description}
                  onChange={handleChange}
                  textAreaProps={{ maxLength: maxDesc }}
                  placeholder={
                    'Ex: "Unlocking our potential for life-long-learning”. St Peter’s Primary School is a mixed school. It has around 338 students from 3 to 11 years old.'
                  }
                />
              </Segment>
              <Segment className={classes.desc}>
                <Description>
                  Maximum of {maxDesc} characters.
                  <br />
                  <br /> Try to describe your school, add its motto, the age
                  groups or how many students you have for example.
                </Description>
              </Segment>
            </Segments>
            <Segments>
              <Segment size={'M'}>
                <div className={classes.checkbox}>
                  <FormCheckbox
                    checked={values.hide_year_group}
                    name="hide_year_group"
                    id="hide_year_group"
                    onChange={handleChange}
                    value={values.hide_year_group}
                  />
                  <label htmlFor="hide_year_group">
                    Do not show age groups on work by my pupils.
                  </label>
                </div>
              </Segment>
            </Segments>
          </Section>
        </form>
      )
    }}
  </Formik>
)

export default injectSheet(styles)(SchoolGeneral)
